import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCoinWon: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconCoinWon"><Path d="M21.5 12C21.5 17.2467 17.2467 21.5 12 21.5C6.75329 21.5 2.5 17.2467 2.5 12C2.5 6.75329 6.75329 2.5 12 2.5C17.2467 2.5 21.5 6.75329 21.5 12Z" stroke="currentColor"/><Path d="M7.5 8.5L9.46875 16.5H10.0312L11.7188 8.5H12.2812L13.9688 16.5H14.5312L16.5 8.5" stroke="currentColor" strokeLinecap="square"/><Path d="M6 12.5H8.5M15.5 12.5H18" stroke="currentColor"/></CentralIconBase>;
});

export default IconCoinWon;
